import GoogleMaps from '../../components/GoogleMaps';
import './style.scss';



function Contact (scrollIntoView) {

    return(
        <section className='contact-screen' style={{backgroundImage:'url(/img/contactbg2.jpg)'}}>
            <div className='container'>
                <h1 className='title'>
                    Kapcsolat
                </h1>
                <div className='contact-information-row'>
                    <div className='contact-information-box' >
                        <h2 className='headline'>
                            Váci Belvárosi Egészségközpont
                        </h2>
                        <p className='contact-information'> 
                            <span>
                                Cím:
                            </span>
                            <p className='address'>
                                2600 Vác, Zrínyi utca 3.
                            </p>
                        </p>
                        
                        <ul class="social-media-links">
                            <li>
                                <a href="https://www.facebook.com/profile.php?id=100057030116693">
                                    <img src="img/fbicon.png" className='social-icon' alt='magictech-logo'/>
                                </a>
                            </li>
                            <li>
                                <a href="">
                                    <img src="img/instaicon.png" className='social-icon' alt='instaicon'/>
                                </a>
                            </li>
                            <li>
                                <a href="">
                                    <img src="img/tiktoklogo.png" className='social-icon' alt='tiktoklogo'/>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className='contact-screen-map'>
                    <div class="map-button">
                        <GoogleMaps/>
                    </div>
                    </div>
                </div>
            </div>
        </section>
    )
}


export default Contact;
